import Link from "next/link"
import { twJoin } from "tailwind-merge"
import { ReactNode } from "react"

const FaqLink = ({ href, children, forSchema }: { href: string; children: ReactNode; forSchema: boolean }) => {
  if (forSchema) {
    return <a href={href}>{children}</a>
  }

  return (
    <Link
      className={twJoin("underline", "text-slate-blue-500", "hover:text-slate-blue-600")}
      target="_blank"
      href={href}
    >
      {children}
    </Link>
  )
}

export const getFaqData = ({ forSchema = false }: { forSchema: boolean }) => [
  {
    title: "What is Traqq time tracking software?",
    description: (
      <>
        Traqq is a time tracking tool that records time against projects, tasks, and clients.
        Each entry includes duration, project context, and billing status.
        Timesheets, reporting, cost calculation, invoicing,
        and profitability metrics all use the same time data.
      </>
    ),
  },
  {
    title: "Does Traqq use employee monitoring?",
    description: (
      <>
        No. There are no screenshots, activity scoring, keystroke logging,
        or idle time tracking.
        Time is recorded by users and attached to the work they are doing.
        Nothing is inferred outside of that.
      </>
    ),
  },
  {
    title: "Who can see tracked data?",
    description: (
      <>
        Employees can review their own time, schedules,
        and project allocation. Access to project,
        financial, and reporting data is controlled through roles,
        which define what each user can view.
      </>
    ),
  },
  {
    title: "Can Traqq replace spreadsheets?",
    description: (
      <>
        Yes. Traqq can replace spreadsheets for time tracking,
        reporting, and billing.
        Over time, these workflows often become harder to manage across multiple tools.
        Traqq unifies them in a single system.
      </>
    ),
  },
  {
    title: "Can I invoice clients from tracked time?",
    description: (
      <>
        Yes. You can create and send invoices in Traqq from billable time.
        Tracked time, billable rates, and invoices stay connected, so you don't need to recreate billing data manually.
      </>
    ),
  },
  {
    title: "Will Traqq fit our existing workflow?",
    description: (
      <>
        Yes. Traqq is designed to work alongside existing processes.
        The browser extension integrates with tools like Jira, Asana,
        Notion, GitHub, Slack, and Figma,
        allowing teams to track time without switching between applications.
      </>
    ),
  },
  {
    title: "Can Traqq scale with growing teams?",
    description: (
      <>
        Yes. As organizations grow, time data usually fragments across tools,
        teams, and formats.
        Traqq keeps tracking, reporting, and capacity planning on the same structure
        so the system doesn’t split as complexity increases.
      </>
    ),
  },
]
